import React from "react";
import PropTypes from "prop-types";
import { getLinkToProject } from "../../common/util/pathUtils";

const SingleColumn = ({ project, showLearnMore, numProjectsToShow }) => {
    const linkToProject = getLinkToProject(project.code);
    return 	<div className="w-100 con-justify text-left">
				<div className="up">
					<div className="img-cover img-1 w-100 d-flex">
						<a className="d-flex w-100" href={linkToProject}><img className="gray-scale" src={project.thumbnailImageUrl} /></a>
					</div>
					<div className="pro-des">
						<h6>{project.locationDescription}</h6>
						<h3 className="mt-0"><a href={linkToProject} className="font-bold text-primary">{project.name}</a></h3>
						<p className="xxsml mt-0 line-17">{project.shortDescription}</p>
					</div>
				</div>
				<div className="down">
					{showLearnMore &&
					<a href={linkToProject} className="xsml btn-primary">Offset Now</a>
					}
				</div>
			</div>
}

SingleColumn.propTypes = {
    project: PropTypes.object,
    showLearnMore: PropTypes.bool
}

export default SingleColumn;